<template>
  <nav-bar title="检查列表" />
  <Content :bottom="0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <ul class="list">
      <li
        class="list-item"
        v-for="item in list"
        :key="item.cid"
        @click="$router.push(`/inspection/${item.ctype}/${item.cid}/${userId}`)"
      >
        {{ item.ctitle }}
      </li>
    </ul>
    <Empty v-if="!list.length && !showLoading" description="暂无记录" />
  </Content>
</template>

<script>
import { ref } from 'vue'
import { getSpecialCheckListByUserId } from '@/api/salehome'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
export default {
  name: 'CheckList',
  props: ['userId'],
  setup(props) {
    const list = ref([])
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
      getSpecialCheckListByUserId,
      data => {
        list.value = data
      },
      props.userId
    )
    getDataLoading()
    return {
      getDataLoading,
      showLoading,
      isLoading,
      list
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  padding: 16px;
  font-size: 14px;
  color: #666;
  .list-item {
    padding: 14px;
    background-color: #fff;
    box-shadow: rgba(87, 107, 146, 0.25) 0px 4px 8px -2px,
      rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-bottom: 16px;
  }
}
</style>
